import {AxiosResponse} from 'axios'
import Client from 'core/api/client'
import {DeviceType} from '../models'

interface IStudyCoordinatorJson {
  createdTime: string
  deletedTime: string | null
  email: string
  id: string
  institutionId: string
}

interface ISubjectToPrescriptionTemplate {
  [subjectId: string]: string
}

export interface IStudyInstitutionJson {
  createdTime: string,
  id: string,
  name: string,
  phone: string,
  subjectIdentifierWhitelist: string[],
  allowedPrescriptionTemplates: string,
  subjectToPrescriptionTemplate: ISubjectToPrescriptionTemplate,
  allowedAges: number[],
  allowedDeviceTypes: DeviceType[],
}

export interface IGetStudyCoordinatorResponseBody {
  studyInstitution: IStudyInstitutionJson
  studyCoordinator: IStudyCoordinatorJson
}

/**
 * Expected response from GET /study/coordinator endpoint
 */
export interface IGetStudyCoordinatorResponse extends AxiosResponse {
  data: IGetStudyCoordinatorResponseBody
}

/**
 * GET /study/coordinator
 */
export function getStudyCoordinator(token: string): Promise<IGetStudyCoordinatorResponse> {
  const headers = { Authorization: `Bearer ${token}` }
  return Client.get('/study/coordinator', { headers, validateStatus: () => true })
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./core/src/api/study_coordinator/getStudyCoordinator.ts